"use strict";
/**
 * Shift Checklist Enums
 *
 * Enums for the shift checklist module. A master `ChecklistActivity` defines a
 * recurring task; a `ChecklistDailyStatus` records, per `(branch, day, activity)`,
 * whether it was done/skipped/not-done and who did it. There is no per-person
 * "run" — status is tracked at the branch+day grain (the matrix model, GH#454).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECKLIST_PRIORITY_LABELS = exports.ChecklistPriority = exports.PER_BRANCH_MODES = exports.CHECKLIST_BRANCH_MODE_LABELS = exports.ChecklistBranchMode = exports.SATISFYING_COMPLETION_STATUSES = exports.CHECKLIST_COMPLETION_STATUS_HELP = exports.CHECKLIST_COMPLETION_STATUS_LABELS = exports.ChecklistCompletionStatus = exports.VIEW_MOMENTS = exports.CHECKLIST_MOMENT_LABELS = exports.ChecklistMoment = void 0;
// --- Moment of shift ---
/**
 * When an activity applies (shown as a tag in the day checklist).
 *
 * - `check_in`  (Entrada): start-of-shift tasks
 * - `check_out` (Salida): end-of-shift tasks
 * - `both`      (Ambos): relevant at both entrada and salida
 * - `any`       (Indistinto): do it once, doesn't matter entrada or salida
 *
 * `both` / `any` are valid ONLY on an activity definition. A view is always
 * requested for a single `check_in` OR `check_out` occasion.
 */
var ChecklistMoment;
(function (ChecklistMoment) {
    ChecklistMoment["check_in"] = "check_in";
    ChecklistMoment["check_out"] = "check_out";
    ChecklistMoment["both"] = "both";
    ChecklistMoment["any"] = "any";
})(ChecklistMoment || (exports.ChecklistMoment = ChecklistMoment = {}));
exports.CHECKLIST_MOMENT_LABELS = {
    [ChecklistMoment.check_in]: "Entrada",
    [ChecklistMoment.check_out]: "Salida",
    [ChecklistMoment.both]: "Ambos",
    [ChecklistMoment.any]: "Indistinto",
};
/** Moments a view can be requested for (never `both` / `any`). */
exports.VIEW_MOMENTS = new Set([
    ChecklistMoment.check_in,
    ChecklistMoment.check_out,
]);
// --- Completion status ---
/**
 * Status of a task within a run (three conscious actions; "unmarked" = no action).
 *
 * - `done`     (Hecho): the task was performed.
 * - `skipped`  (No hacía falta): evaluated and deemed unnecessary (e.g. the
 *              sanitary dispensers were already full). Carries a reason.
 * - `not_done` (No se pudo): consciously not done because it couldn't be (e.g.
 *              missing material, no time). Carries a reason.
 */
var ChecklistCompletionStatus;
(function (ChecklistCompletionStatus) {
    ChecklistCompletionStatus["done"] = "done";
    ChecklistCompletionStatus["not_done"] = "not_done";
    ChecklistCompletionStatus["skipped"] = "skipped";
})(ChecklistCompletionStatus || (exports.ChecklistCompletionStatus = ChecklistCompletionStatus = {}));
exports.CHECKLIST_COMPLETION_STATUS_LABELS = {
    [ChecklistCompletionStatus.done]: "Hecho",
    [ChecklistCompletionStatus.skipped]: "No hacía falta",
    [ChecklistCompletionStatus.not_done]: "No se pudo",
};
/** Tooltip help text per status (for the UI controls). */
exports.CHECKLIST_COMPLETION_STATUS_HELP = {
    [ChecklistCompletionStatus.done]: "Se realizó.",
    [ChecklistCompletionStatus.skipped]: "Se evaluó y no era necesario hacerla (ej. las sanitas ya estaban llenas).",
    [ChecklistCompletionStatus.not_done]: "Conscientemente no se hizo porque no se pudo (ej. faltó material, no dio tiempo).",
};
/** Statuses that reset the overdue clock (i.e. count as "the task was done"). */
exports.SATISFYING_COMPLETION_STATUSES = new Set([
    ChecklistCompletionStatus.done,
]);
// --- Branch mode (how an activity relates to branches) ---
/**
 * How an activity's doneness is scoped across branches.
 *
 * - `specific` (Sucursales específicas): applies to the listed `branchIds`;
 *   done/overdue tracked PER branch.
 * - `each`     (Todas — cada una): applies to every branch; each branch does
 *   its own; done/overdue tracked PER branch (e.g. "Barrer recepción").
 * - `any`      (Cualquier sucursal): done ONCE for the whole org regardless of
 *   branch; done/overdue tracked GLOBALLY (e.g. "Enviar recordatorios de vacuna").
 */
var ChecklistBranchMode;
(function (ChecklistBranchMode) {
    ChecklistBranchMode["specific"] = "specific";
    ChecklistBranchMode["each"] = "each";
    ChecklistBranchMode["any"] = "any";
})(ChecklistBranchMode || (exports.ChecklistBranchMode = ChecklistBranchMode = {}));
exports.CHECKLIST_BRANCH_MODE_LABELS = {
    [ChecklistBranchMode.specific]: "Sucursales específicas",
    [ChecklistBranchMode.each]: "Todas (cada una)",
    [ChecklistBranchMode.any]: "Cualquier sucursal",
};
/** Branch modes whose doneness is tracked per-branch (not global). */
exports.PER_BRANCH_MODES = new Set([
    ChecklistBranchMode.specific,
    ChecklistBranchMode.each,
]);
// --- Priority ---
var ChecklistPriority;
(function (ChecklistPriority) {
    ChecklistPriority["high"] = "high";
    ChecklistPriority["medium"] = "medium";
    ChecklistPriority["low"] = "low";
})(ChecklistPriority || (exports.ChecklistPriority = ChecklistPriority = {}));
exports.CHECKLIST_PRIORITY_LABELS = {
    [ChecklistPriority.high]: "Alta",
    [ChecklistPriority.medium]: "Media",
    [ChecklistPriority.low]: "Baja",
};
